<template>
    <div class="News">
        <carousel/>
        <div class="breadcrumb-div">
            <div class="FL">
                <img src="../../static/images/u177.png" alt="" class="breadcrumb-img">
            </div>
            <div class="FL breadcrumb-title">
                {{ $t('lang.position') }}：
            </div>
            <div class="FL">
                <a-breadcrumb class="breadcrumb-main">
                    <a-breadcrumb-item> <a href="/">{{ $t('lang.index1') }}</a></a-breadcrumb-item>
                    <a-breadcrumb-item>{{ $t('lang.Qualification') }}</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
        </div>
        <div class="main-div" style="height: 830px">
            <div class="FL MT30">
                <navComponent class="MT30"/>
            </div>
            <div class="FR" style="width: 1120px;">
                <div class="int-title margin-auto font-weight text-align">{{ $t('lang.Qualification') }}</div>
                <div class="margin-auto font-weight text-align int-title2">{{ $t('lang.Foot') }}</div>
                <a-row type="flex">
                    <a-col :span="8" v-for="(item,i) in newsList" :key="i" class="text-align MT30 MB20">
                        <div>
                            <img :src="item.image" style="width: 200px;height: 300px" @click="getInfo(item.id)"
                                 class="cursor-pointer" :alt="item.title">
                        </div>
                        <p class="p-over1 post-one margin-auto fs18">{{ item.title }}</p>
                        <!--                        <p class="p-over post-one margin-auto">{{ item.introduction }}</p>-->
                        <div class="line1 post-one"></div>
                        <div style="text-align: right;margin-right: 40px">
                            <a-button @click="getInfo(item.id)">{{ $t('lang.more') }}</a-button>
                        </div>
                    </a-col>
                </a-row>
                <!--                <div style="text-align: right;margin-right: 40px;margin-bottom: 40px;margin-top: 20px">-->
                <!--                    <a-pagination :current="current" :total=total @change="changePage" :defaultPageSize="limit"/>-->
                <!--                </div>-->
            </div>
            <div class="ClearFloat"></div>
        </div>
    </div>
</template>

<script>
import carousel from "@/components/carousel";
import navComponent from "@/components/navcomponents";
import {get} from "@/utils";

export default {
    name: "Qualification",
    components: {
        navComponent,
        carousel,
    },
    data() {
        return {
            newsList: [],
            total: 0,
            limit: 6,
            current: 1,
        }
    },
    mounted() {
        document.title = '贝威科技(潍坊)有限公司-资质认证'
        get('article/getArticleList', {}).then(res => {
            this.newsList = res.data.list;
        }).catch(() => {
        })
        const box = document.getElementsByTagName('html');
        box[0].scrollTop = 0;
    },
    methods: {
        getInfo(id) {
            // this.$router.push({path: '/newInfo', query: {id}});
            this.$router.push({path: '/qualificationInfo/' + id + '.html'})
        },
    },
}
</script>

<style scoped>
.post-one {
    width: 300px;
    margin-left: 40px;
    margin-top: 20px;
    margin-bottom: 10px;
}

.fs18 {
    font-size: 16px;
}

.line1 {
    border-bottom: 1px solid #2a2222;
}
</style>
